import { render, staticRenderFns } from "./NotPartner.vue?vue&type=template&id=bedc2b0a&scoped=true"
import script from "./NotPartner.vue?vue&type=script&lang=js"
export * from "./NotPartner.vue?vue&type=script&lang=js"
import style0 from "./NotPartner.vue?vue&type=style&index=0&id=bedc2b0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedc2b0a",
  null
  
)

export default component.exports